import React, { useState, useEffect } from 'react';

//components
import CustomBreadcrumbs from '../../Components/CustomBreadcrumbs';
import DashboardHeader from '../../ClientEngagement/DashboardHeader';
import ColosseumProjectDetailsModal from '../ProjectTimeline/ColosseumProjectDetailsModal';
import ColosseumOrderSummary from './ColosseumOrderSummary';
import ColosseumQuotationsTable from './ColosseumQuotationsTable';
import AddQuotationModal from './AddQuotationModal';
import ClosedProject from '../../Components/ClosedProject';

//utils
import { axiosInstance } from '../../utils/axiosInterceptor';
import { Box, createTheme, Grid, Typography } from '@mui/material';
import { useParams, useHistory } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import moment from 'moment';

//assets
import { ReactComponent as MagicIcon } from '../../assests/magic.svg';
import { ReactComponent as ManualIcon } from '../../assests/manual.svg';

//styles
import {
  PageContainer,
  QuotationsContainer,
  CustomButton,
} from './ColosseumQuotation.styles';

const ColosseumQuotations = ({ isAdmin }) => {
  const [profile, setProfile] = useState(null);
  const [loading, setLoading] = useState(true);
  const [project, setProject] = useState(null);
  const [isClose, setIsClose] = useState(false);
  const [showProjectDetail, setShowProjectDetail] = useState(false);
  const [showAddModal, setShowAddModal] = useState(false);
  const [selectionMode, setSelectionMode] = useState(false);
  const [selectedQuotation, setSelectedQuotation] = useState(null);
  const [currentMode, setCurrentMode] = useState('manual');
  const [orderState, setOrderState] = useState({
    confirm: false,
    order: null,
  });
  const history = useHistory();
    const isPM = localStorage.PM;

  const toggleProjectDetail = () => {
    setShowProjectDetail(!showProjectDetail);
  };

  const toggleAddModal = () => {
    setShowAddModal(!showAddModal);
  };

  const toggleSelectionMode = () => {
    setSelectionMode(!selectionMode);
    setSelectedQuotation(null);
  };

  useEffect(() => {
    if (currentMode === 'manual') {
      setSelectedQuotation(null);
    }
  }, [currentMode]);

  const { enqueueSnackbar } = useSnackbar();
  const { type, id } = useParams();

  const fetchProfile = () => {
    setLoading(true);
    axiosInstance
      .get('/users/getProfile')
      .then((resp) => {
        setProfile(resp.data.data);
        console.log(resp);
        setLoading(false);
      })
      .catch((err) => {
        setLoading(false);
      });
  };
  const fetchProject = async () => {
    const res = await axiosInstance.get(
      `/3d/client/singleProject/${type}/${id}`
    );
    console.log(res);
    setProject(res.data.project);
    setIsClose(res.data.project.isClosed);

    if (res.data.project.orderSummary) {
      const order = res.data.project.orderSummary;
      setOrderState({
        confirm: true,
        order: order,
      });

      setSelectedQuotation({
        quantity: order.quantity,
        pricePerQty: order.totalCost,
        shippingCost: order.shippingCost,
        totalCost: order.grandTotal,
      });
      setCurrentMode(order.isMagic ? 'magic' : 'manual');
      console.log(order, 'here is the order!!');
    }
  };

  const handleOrderConfirm = async () => {
    const data = {
      unitCost: selectedQuotation.unitCost,
      cost: Number(
        (Number(selectedQuotation.pricePerQty) / 1.18)
          .toFixed(2)
          .replace(/[.,]00$/, '')
      ),
      quantity: selectedQuotation.quantity,
      totalCost: selectedQuotation.pricePerQty,
      shippingCost: selectedQuotation.shippingCost,
      grandTotal: selectedQuotation.totalCost,
      isMagic: currentMode === 'magic',
    };

    try {
      const res = await axiosInstance.post(
        `/3d/client/addOrderDetail/${type}/${id}`,
        data
      );
      console.log(res);
      enqueueSnackbar('Order confirmed successfully!', { variant: 'success' });
      if (isAdmin) {
        history.push(`admin/3d/timeline/${type}/{id}`);
      } else {
        history.push(`/3dcolosseum/${type}/${id}`);
      }
    } catch (err) {
      console.log(err);
      enqueueSnackbar('Something went wrong!', { variant: 'error' });
    }

    console.log(selectedQuotation);
    console.log(data);
  };

  useEffect(() => {
    fetchProject();
  }, [type, id]);

  useEffect(() => {
    fetchProfile();
    fetchProfile();
  }, []);
    console.log("profile", profile);
  return (
    <Box sx={isClose ? { pointerEvents: 'none' } : {}}>
      {isClose && <ClosedProject />}

      {!loading && project ? (
        <PageContainer>
          <DashboardHeader profile_data={profile} isBlack={true} />
          <QuotationsContainer>
            {isAdmin ? (
              <CustomBreadcrumbs
                data={[
                  {
                    name: 'Home',
                    link: `/${isPM? "pm" : ""}`,
                  },
                  {
                    name: 'EB 3D Colosseum',
                    link: `/${isPM? "pm" : "admin"}/3d`,
                  },
                  {
                    name: 'Quotations',
                    link: `/${isPM? "pm" : ""}/3d/quotations/${type}/${id}`,
                  },
                ]}
              />
            ) : (
              <CustomBreadcrumbs
                data={[
                  {
                    name: 'Home',
                    link: '/',
                  },
                  {
                    name: 'EB 3D Colosseum',
                    link: '/3dcolosseum/projects',
                  },
                  {
                    name: 'View Details',
                    link: `/3dcolosseum/${type}/${id}`,
                  },
                  {
                    name: 'Quotations',
                    link: `/3dcolosseum/quotations/${type}/${id}`,
                  },
                ]}
              />
            )}
            <div className="title">Quotations</div>
            <Box className="container1">
              <Box>
                <Typography className="projectName">
                  {project.projectName} - {project.projectOwner.enterpriseName}
                </Typography>
                <Typography className="projectTime">
                  {' '}
                  Project Created on:{' '}
                  {moment(project?.createdOn).format('MMMM Do YYYY, h:mm a')}
                </Typography>
              </Box>
              <Box
                sx={{
                  borderBottom: '1px solid #0702FC',
                  color: '#0702FC',
                  fontWeight: 500,
                  cursor: 'pointer',
                }}
                onClick={toggleProjectDetail}
              >
                View Project Details
              </Box>
              <ColosseumProjectDetailsModal
                state={showProjectDetail}
                toggleModal={toggleProjectDetail}
                project={project}
                type={type}
              />
            </Box>
            <Box className="button-container">
              {isAdmin ? (
                <div>
                  <CustomButton
                    fill
                    onClick={toggleSelectionMode}
                    disabled={orderState.confirm}
                  >
                    Selection Mode: {selectionMode ? 'ON' : 'OFF'}
                  </CustomButton>
                  <CustomButton
                    onClick={toggleAddModal}
                    disabled={orderState.confirm}
                  >
                    Add Quotation
                  </CustomButton>
                </div>
              ) : (
                <div>
                  <CustomButton
                    fill={currentMode === 'magic'}
                    onClick={() => {
                      setCurrentMode('magic');
                    }}
                    disabled={orderState.confirm}
                  >
                    <MagicIcon className="qbtn" />
                    Magic Recommendation
                  </CustomButton>
                  <CustomButton
                    onClick={() => {
                      setCurrentMode('manual');
                    }}
                    fill={currentMode === 'manual'}
                    disabled={orderState.confirm}
                  >
                    <ManualIcon className="qbtn" />
                    Manual Selection
                  </CustomButton>
                </div>
              )}
              {isAdmin ? (
                <AddQuotationModal
                  state={showAddModal}
                  toggleModal={toggleAddModal}
                  id={id}
                  type={type}
                />
              ) : null}

              {type !== 'prebuiltCase' ? (
                <div>
                  <a href={project.cadFile.location}>
                    <CustomButton>Download File</CustomButton>
                  </a>
                </div>
              ) : null}
            </Box>
            <ColosseumQuotationsTable
              project={project}
              selectionMode={selectionMode}
              selectQuotation={setSelectedQuotation}
              isAdmin={isAdmin}
              mode={currentMode}
              disabled={orderState.confirm}
              selectedQuotation={selectedQuotation}
            />
          </QuotationsContainer>
          {selectedQuotation !== null ? (
            <ColosseumOrderSummary
              selectedQuotation={selectedQuotation}
              confirmOrder={handleOrderConfirm}
              orderState={orderState}
            />
          ) : null}
        </PageContainer>
      ) : null}
    </Box>
  );
};

export default ColosseumQuotations;
